import { render } from "./fleet.cattle.io.helmop.vue?vue&type=template&id=2c18fe16&scoped=true"
import script from "./fleet.cattle.io.helmop.vue?vue&type=script&lang=js"
export * from "./fleet.cattle.io.helmop.vue?vue&type=script&lang=js"

import "./fleet.cattle.io.helmop.vue?vue&type=style&index=0&id=2c18fe16&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c18fe16"]])

export default __exports__